module.exports = __webpack_public_path__ + "static/media/ripplematchlogo.2043871b.png";